import { PURGE } from 'redux-persist/es/constants';
import { THEME } from '../../constants/theme';

const initialState = {
  network: true,
  activity: false,
  language: 'en',
  theme: THEME.LIGHT,
  banner: {
    products: [],
    instance: null
  },
  cart: {
    open: false
  }
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'App/SET_NETWORK':
      return {
        ...state,
        network: action.payload
      };

    case 'App/SET_ACTIVITY':
      return {
        ...state,
        activity: action.payload
      };

    case 'App/SET_LANG':
      return {
        ...state,
        language: action.payload
      };

    case 'App/CHANGE_THEME':
      const currTheme = state.theme;
      let newTheme = action.payload;
      if (!newTheme) {
        if (currTheme === THEME.LIGHT) newTheme = THEME.DARK;
        else newTheme = THEME.LIGHT;
      }
      return {
        ...state,
        theme: newTheme
      };

    case 'App/BANNER_OPEN':
      return {
        ...state,
        banner: {
          ...state.banner,
          instance: action.payload
        }
      };
    case 'App/BANNER_ADD':
      return {
        ...state,
        banner: {
          ...state.banner,
          products: [...state.banner.products, action.payload]
        }
      };
    case 'App/BANNER_CLOSE':
      return {
        ...state,
        banner: {
          ...state.banner,
          instance: null,
          products: []
        }
      };

    case 'App/SET_CART_OPEN':
      return {
        ...state,
        cart: {
          ...state.cart,
          open: action.payload
        }
      };

    case PURGE:
      return {
        ...initialState,
        language: state.language,
        theme: state.theme
      };

    default:
      return state;
  }
};

export default appReducer;
